import * as QuizActions from './quizActions';
import { AuthenticationTypes } from '../../lib/PST.Web.Common/src/services/authentication/base';

export const QuizMiddleware = ({ dispatch }) => (next) => (action) => {
    if (action.type === AuthenticationTypes.LOG_OUT) {
        dispatch(QuizActions.clearState());
    }

    return next(action);
};
